import { render } from "./UnsplashSection.vue?vue&type=template&id=f638a346"
import script from "./UnsplashSection.vue?vue&type=script&lang=js"
export * from "./UnsplashSection.vue?vue&type=script&lang=js"

import "./UnsplashSection.vue?vue&type=style&index=0&id=f638a346&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__